export { default as RenderGamificationEntry } from './gamificationEntry.component';
export * from './gamificationEntry.component';
